import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  }
};

const enhance = compose();

const InvoiceGochiTableHead = enhance(({ order, orderBy, onRequestSort }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell>
          <TableSortLabel>No</TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'invoicedAt' ? order : false}>
          <TableSortLabel
            active={orderBy === 'invoicedAt'}
            direction={order}
            onClick={() => {
              onRequestSort('invoicedAt');
            }}
          >
            利用日
          </TableSortLabel>
        </TableCell>
        <TableCell
          sortDirection={orderBy === 'userDisplayName' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'userDisplayName'}
            direction={order}
            onClick={() => {
              onRequestSort('userDisplayName');
            }}
          >
            利用者氏名
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'menuName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuName'}
            direction={order}
            onClick={() => {
              onRequestSort('menuName');
            }}
          >
            利用サービス
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'transferAmount' ? order : false}>
          <TableSortLabel
            active={orderBy === 'transferAmount'}
            direction={order}
            onClick={() => {
              onRequestSort('transferAmount');
            }}
          >
            利用金額
          </TableSortLabel>
        </TableCell>
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(InvoiceGochiTableHead);
